module.exports = __webpack_public_path__ + "static/media/gsb-iconHousewares&Electronic.20c29e56.svg";